import { createElement } from "react";
import { createRoot } from "react-dom/client";
// Side-effect import: initializes PostHog before the banner (or anything else) renders.
import "./posthog";
import CookieBanner from "../components/CookieBanner";

// Zudoku has no slot that renders on every page at every viewport (the header
// slots disappear at mobile widths), so the consent banner mounts itself into
// document.body as its own React root. Imported for its side effect from
// zudoku.config.tsx; no-op during build-time prerendering (Node).
if (typeof window !== "undefined") {
  const mount = () => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    createRoot(container).render(createElement(CookieBanner));
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount, { once: true });
  } else {
    mount();
  }
}
